import styles from "./productdetails.module.css";
import { Outlet, useLocation, useParams } from "react-router-dom";
import {
  useSingleProductQuery,
  useProductsQuery,
} from "../../../queries/useProductsQuery";

import ProductImage from "./ProductImage";
import ProductInfo from "./ProductInfo";
import ProductTabs from "./ProductTabs";
import RelatedProducts from "./RelatedProducts";
import { Banner, BreadCrumb } from "../../../components/shared/index";
import { useAddToCart } from "../../../queries/useCartQuery";

const ProductDetails = () => {
  const { productSlug } = useParams();
  const { pathname } = useLocation();

  const parts = pathname.split("/");
  const newPath = parts[parts.length - 2];

  // ✅ Single product
  const {
    data: productData,
    isPending: isSingleProductLoading,
    isError,
    error,
    isFetching,
  } = useSingleProductQuery(productSlug);

  const { mutate: addToCart, isPending: isCartPending } = useAddToCart();

 const images = productData
  ? [
      // add thumb image first
      productData.thumb_image
        ? {
            image: productData.thumb_image,
            isThumb: true,
          }
        : null,

      // then gallery images
      ...(productData.product_image_galleries || []),
    ].filter(Boolean)
  : [];

  // ✅ Fetch related using category_id
  const {
    data: relatedData,
    isPending: isRelatedLoading,
  } = useProductsQuery(
    { category_id: productData?.category_id },
    {
      enabled: !!productData?.category_id,
    }
  );

  // ✅ IMPORTANT: correct path
  const relatedProducts = relatedData?.products?.data || [];

  // ✅ Filter
  const filteredRelatedProducts = relatedProducts
    .filter(
      (item) =>
        item.id !== productData?.id &&
        item.qty > 0
    )
    .slice(0, 8);

  console.log("Related API:", relatedData);
  console.log("Final Related:", filteredRelatedProducts);
  console.log(productData,"productdata"); 
console.log("FULL PRODUCT DATA:", productData);
  return (
    <section className={styles.productDetailsMain}>
     {/* <BreadcrumbBanner
  productData={productData}
  imageUrl="https://images.unsplash.com/photo-1628771065518-0d82f1938462?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8cGhhcm1hY3l8ZW58MHx8MHx8fDA%3D"
   heading="Quality Healthcare You Can Trust"
/> */}   

      <div className={styles.detailsWrapper}> 
      <ProductImage
  images={images}
  productId={productData?.id}
  productName={productData?.name}
  isPending={isSingleProductLoading}
  isError={isError}
  error={error}
/>

        <ProductInfo
          productData={productData}
          addToCart={addToCart}
          isPending={isSingleProductLoading}
          isCartPending={isCartPending}
          isError={isError}
          error={error}
        />
      </div>  

      <ProductTabs
        productData={productData}
        isPending={isSingleProductLoading}
        isFetching={isFetching}
      />

      <Outlet />

      {/* ✅ FINAL RELATED PRODUCTS */}
      <RelatedProducts
        relatedProducts={filteredRelatedProducts}
        isPending={isRelatedLoading}
      />
    </section>
  );
};

const BreadcrumbBanner = ({ productData, imageUrl, heading }) => {
  const categoryName = productData?.category?.name;
  const categorySlug = productData?.category?.slug;

  const subCategoryName =
    productData?.subcategory?.name ||
    productData?.sub_category?.name;

  const subCategorySlug =
    productData?.subcategory?.slug ||
    productData?.sub_category?.slug;

  const childCategoryName = productData?.child_category?.name;
  const childCategorySlug = productData?.child_category?.slug;

  const customPaths = [
    { label: "Shop", path: "/shop" },
  ];

  // Category
  if (categoryName && categorySlug) {
    customPaths.push({
      label: categoryName,
      path: `/shop/${categorySlug}`,
    });
  }

  // Subcategory
  if (subCategoryName && subCategorySlug) {
    customPaths.push({
      label: subCategoryName,
      path: `/shop/${categorySlug}/${subCategorySlug}`,
    });
  }

  // Child category
  if (childCategoryName && childCategorySlug) {
    customPaths.push({
      label: childCategoryName,
      path: `/shop/${categorySlug}/${subCategorySlug}/${childCategorySlug}`,
    });
  }
if (productData?.name && productData?.slug) {
  customPaths.push({
    label: productData.name,
    path: window.location.pathname,
  });
}
  console.log("Breadcrumb Paths:", customPaths);


  return (
    <>
      <BreadCrumb customPaths={customPaths} />
    
      <Banner
        heading={heading || "Product Details"}
        imageUrl={imageUrl}
      />
    </>
  );

  
};

export default ProductDetails;

